module.exports = __webpack_public_path__ + "static/media/Printed Materials.93a6493f.png";